var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useRef } from 'react';
import { isEmpty } from 'ramda';
/**
 * Generates a method to perform a download and provides a RefObject to trigger said download
 * @returns object which contains a RefObject that can be attached
 * in your implementation to trigger the download and a function to perform the
 * download of a given file
 */
export const useDownloadFile = () => {
    const downloadRef = useRef(null);
    const download = (ref, signedUrl) => __awaiter(void 0, void 0, void 0, function* () {
        if (ref.current) {
            ref.current.href = signedUrl;
            if (!isEmpty(ref.current.href)) {
                ref.current.click();
            }
        }
    });
    return { download, downloadRef };
};
